export default __webpack_public_path__ + "static/media/location-unavailable-desktop.474607c6.png";